import React, { useContext } from 'react';
import closeSVG from '../images/close_icon.svg';
import { LiveChatContext } from '../context/LiveChat';

const LiveChatLayout = ({ children }) => {
  const context = useContext(LiveChatContext);

  return (
    <>
      {children}
      <div className="fixed bottom-0 md:right-16 z-20">
        <iframe
          src="https://live-agent.ezpay888.com/cs/ezpaya.html"
          title="live chat"
          className={`${
            context?.state?.showChat ? 'block' : 'hidden'
          } rounded h-screen w-screen md:h-[600px] md:w-[340px]`}
        />
        <button
          type="button"
          className={`${
            context?.state?.showChat ? 'block' : 'hidden'
          } rounded fixed top-0 right-6 m-4 p-2 bg-black text-white opacity-50
          md:top-auto md:bottom-[532px] md:right-[100px]`}
          onClick={() => context?.dispatch({ type: 'update', payload: false })}
        >
          <img src={closeSVG} alt="close" className="w-[20px] h-[20px] m-0" />
        </button>
      </div>
    </>
  );
};

export default LiveChatLayout;
